require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./collaboratrices-et-collaborateurs-du-sps-1-1-5-4.json") })
        }
      }, "path---collaboratrices-et-collaborateurs-du-sps-1-1-5-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---collaboratrices-et-collaborateurs-du-sps-1-1-5-4!./.cache/json/collaboratrices-et-collaborateurs-du-sps-1-1-5-4.json
// module id = 375
// module chunks = 231608221292675